export default __webpack_public_path__ + "static/media/ic_point.ee517efd.svg";